import React from 'react';
import './Button.scss'; // Optional: If using external CSS

interface ButtonCTAProps {
  onClick: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  text: string;
}

const Button: React.FC<ButtonCTAProps> = ({ onClick, text, style }) => {
  return (
    <div
      className="ButtonCTA"
      onClick={onClick}
      style={style}
    >
      {text}
    </div>
  );
};

export default Button;